// @flow
import React from 'react';
import type { Categories } from 'store/modules/quotes';
import QuoteLikeButton from 'components/quote/QuoteLikeButton';
import { fromNow } from 'lib/common';
import QuoteActionButtons from '../QuoteActionButtons';
import QuoteMobileShare from '../QuoteMobileShare/QuoteMobileShare';
import './QuoteHead.scss';

type Props = {
  id: string,
  title: string,
  categories: Categories,
  user: {
    username: string,
    id: string,
    thumbnail: ?string,
    short_bio: ?string,
  },
  likes: number,
  liked: boolean,
  ownQuote: boolean,
  onToggleLike: () => void,
  onAskRemove: () => void,
  date: string,
  logged: boolean,
  url: string,
  isPrivate: boolean,
  informCopy: () => void,
};

const QuoteHead = ({
  id,
  title,
  date,
  categories,
  user,
  likes,
  liked,
  ownQuote,
  onToggleLike,
  onAskRemove,
  logged,
  isPrivate,
  url,
  informCopy,
}: Props) => {
  return (
    <div className="QuoteHead">
      <h1>{title}</h1>
      <div className="date-and-likes">
        <div className="date">{fromNow(date)}</div>
        <div className="placeholder" />
        <QuoteMobileShare
          url={url}
          title={title}
          username={user.username}
          informCopy={informCopy}
        />
        <QuoteLikeButton onClick={onToggleLike} liked={liked} likes={likes} disabled={!logged} />
      </div>
      <div className="separator" />
      {ownQuote && <QuoteActionButtons id={id} onAskRemove={onAskRemove} />}
    </div>
  );
};

QuoteHead.Placeholder = () => (
  <div className="QuoteHead placeholder">
    <div className="gray-block _title" />
    <div className="date-and-likes">
      <div className="date">
        <div className="gray-block _date" />
      </div>
      <div className="placeholder" />
    </div>
    <div className="separator" />
  </div>
);
export default QuoteHead;



// WEBPACK FOOTER //
// ./src/components/quote/QuoteHead/QuoteHead.js